import { Ban } from "lucide-react";

import { useAuthStore } from "@/client/features/auth/auth-store";

/**
 * Persistent banner shown to a deactivated tenant's members (PE-991, Workflow
 * B). Portal login and read access are retained, but self-service actions are
 * disabled server-side; this makes the state obvious and points them at their
 * account team. Renders nothing for active tenants and for staff.
 */
export function DeactivationBanner() {
  const deactivated = useAuthStore((s) => s.deactivated);
  if (!deactivated) {
    return null;
  }
  return (
    <div
      role="status"
      className="mb-4 flex items-start gap-3 rounded-lg border border-[var(--warning-solid)] bg-[var(--warning-bg)] px-4 py-3 text-sm text-[var(--warning-fg)]"
    >
      <Ban className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-medium">This account is deactivated</p>
        <p className="text-xs opacity-80">
          You can still view your information and reach support, but creating or changing resources
          (SSH keys, network access, team invites, API tokens) is disabled, and API tokens no longer
          work. Contact your Mantle account team to reactivate.
        </p>
      </div>
    </div>
  );
}
